import Helpers from "../../commons/helpers";
import IdentityClient from "./IdentityClient";

import { IService } from "../../commons/interfaces";
import { Constants } from "../../constants/constants";

interface IGetAllServiceRequest {
    searchText: string;
}

const ServiceService = {

    async getAll(data?: IGetAllServiceRequest): Promise<IService[]> {
        const newdata = Helpers.isNullOrEmpty(data) ? "" : Helpers.handleFormatParams(data || {});
        const query = Helpers.isNullOrEmpty(newdata) ? "" : `?${newdata}`;

        const result = await IdentityClient().get(`${Constants.ApiPath.SERVICE.GET_ALL}${query}`);

        return result.data.result;
    },
}

export default ServiceService;
